import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { RankMutationKeys } from '../../../keys'
import { deleteRank } from '../../services'

interface UseMutationDeleteRankProps {
	id: string
}

export default function useMutationDeleteRank(
	props?: UseBaseMutationOptions<void, UseMutationDeleteRankProps>,
) {
	return useMutation({
		mutationKey: [RankMutationKeys.DeleteRank],
		mutationFn: ({ id }) => deleteRank(id),
		...props,
	})
}
